export const cardSize = 36
export const cardGutter = 3
export const cardTopSpace = 6
const daysInARow = 7

export const monthWidth = cardSize * daysInARow + cardGutter * (daysInARow - 1)
export const monthSpace = 60

export const defaultMinDate = new Date('1970-01-01')
